import { render, staticRenderFns } from "./admin_topic.vue?vue&type=template&id=4f2a4025&scoped=true&"
import script from "./admin_topic.vue?vue&type=script&lang=js&"
export * from "./admin_topic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a4025",
  null
  
)

export default component.exports